<mat-card class="p-0">
	<mat-card-content>
		<div *ngIf="!isLoadingCarrierSearch && !IS_NOT_EMPTY(carrierSearchString)">
			<h2 class="p-1 py-0 mb-0 label-text-light">Recently Viewed Carriers</h2>
			<div class="p-1 py-0 label-text-light" fxLayout="row">
				Showing the most recently matched carriers
			</div>
		</div>

		<div
			*ngIf="isLoadingCarrierSearch && utilService.isNullOrUndefined(carriersList)"
			class="m-t-1 m-b-1"
		>
			<app-default-progress-bar> </app-default-progress-bar>
		</div>

		<div
			*ngIf="!isLoadingCarrierSearch && !utilService.isNullOrUndefined(carriersList)"
			class="p-1"
		>
			<h2
				*ngIf="carriersList.length > 0 && IS_NOT_EMPTY(carrierSearchString)"
				class="py-0 mb-0 label-text-light"
			>
				Matching Carriers
			</h2>
			<h2 *ngIf="carriersList.length == 0" class="py-0 mb-0 label-text-light">
				No matching carrier found for the search.
			</h2>

			<mat-card
				(click)="showFullProfile(carrier)"
				*ngFor="let carrier of carriersList; let cIndex = index"
				class="m-t-1 cursor-pointer"
			>
				<mat-card-content class="primary-text font-size-14">
					<div fxLayout="row">
						<div class="ellipsis" fxFlex="33" fxLayoutAlign="start center">
							<b>
								<span
									[innerHTML]="carrier.businessName | highlightText: carrierSearchString"
								></span>
								<img
									*ngIf="
										SHOW_IN_NETWORK_LOGO(
											CARRIER_QUALITY_ENABLED,
											carrier.dot,
											isCarrierVettingIntegrationEnabled,
											carrier?.vettingSource,
											carrier.vettingSourceId,
											carrierVettingService,
											carrier.id,
											carrier.customerCarrier
										)
									"
									class="carrier_header_icons"
									[src]="carrierVettingService.logo(carrier?.vettingSource)"
									[matTooltip]="
										carrierVettingService.tooltip(
											carrier?.vettingSource,
											carrier?.carrierOnboardedOn,
											carrier?.lastVettingTime
										)
									"
								/>
								<img
									*ngIf="carrier?.haulPayApproved && environment.SHOW_QUALITY"
									class="carrier_header_icons"
									[src]="haulpayService.logo()"
									[matTooltip]="haulpayService.tooltip()"
								/>
							</b>
						</div>
						<div class="ellipsis" fxFlex="40" fxFlexOffset="2" fxLayoutAlign="start center">
							<span
								*ngIf="
									!utilService.isNullOrUndefined(carrier.customerCode) &&
									carrier.customerCode.length > 0 &&
									IS_NOT_EMPTY(carrier.customerCode)
								"
							>
								Carrier Code: {{ carrier.customerCode }}
							</span>
						</div>
						<div
							*ngIf="IS_NOT_EMPTY(carrier.carrierHQ)"
							class="ellipsis"
							fxFlex="23"
							fxFlexOffset="2"
							fxLayoutAlign="start center"
						>
							HQ:{{ carrier.carrierHQ }}
						</div>
					</div>
					<div class="mt-3" fxLayout="row">
						<div fxFlex="35" fxLayoutAlign="start center">
							<span
								*ngIf="
									!utilService.isNullOrUndefined(carrier.dot) ||
									!utilService.isNullOrUndefined(carrier.mc)
								"
							>
								<span
									(click)="
										$event.stopPropagation();
										utilService.copyToClipboard(carrier.mc, COPY_TO_CLIPBOARD_MSGS.MC)
									"
									*ngIf="!utilService.isNullOrUndefined(carrier.mc)"
								>
									MC: {{ carrier.mc }}
								</span>
								{{
									!utilService.isNullOrUndefined(carrier.dot) &&
									!utilService.isNullOrUndefined(carrier.mc)
										? ' / '
										: ''
								}}
								<span
									(click)="
										$event.stopPropagation();
										utilService.copyToClipboard(carrier.dot, COPY_TO_CLIPBOARD_MSGS.DOT)
									"
									*ngIf="!utilService.isNullOrUndefined(carrier.dot)"
								>
									{{ !utilService.isNullOrUndefined(carrier.dot) ? 'DOT: ' + carrier.dot : '' }}
								</span>
							</span>
						</div>
						<div fxFlex fxLayoutAlign="start center">
							<span
								(click)="$event.stopImmediatePropagation(); onboardCarrier(carrier)"
								*ngIf="
									isIntegrationLinkAvailable &&
									SHOW_ONBOARD_CARRIER_LINK(
										CARRIER_QUALITY_ENABLED,
										carrierVettingService,
										carrier?.vettingSource,
										carrier.customerCarrier,
										carrier.dot,
										isCarrierVettingIntegrationEnabled,
										carrier.vettingSourceId,
										carrierVettingService.isCarrierOnboarded(carrier.id)
									)
								"
								class="link ml-6 font-size-12"
							>
								Onboard Carrier
							</span>
							<div
								class="full-width p-r-1"
								(click)="$event.stopPropagation()"
								fxLayoutAlign="space-between center"
								*ngIf="
									accountSettings.CARRIER_QUALITY &&
									SHOW_IN_NETWORK_LOGO(
										CARRIER_QUALITY_ENABLED,
										carrier.dot,
										isCarrierVettingIntegrationEnabled,
										carrier?.vettingSource,
										carrier.vettingSourceId,
										carrierVettingService,
										carrier.id,
										carrier.customerCarrier
									)
								"
							>
								<span class="font-size-14 font-weight-bold">Quality Score: </span>
								<span
									class="font-size-14 font-weight-bold {{
										sharedService.getCarrierScoreToDisplay(carrier.ccScore, carrier.active) || 'N/A'
									}}"
								>
									{{
										sharedService.getCarrierScoreToDisplay(carrier.ccScore, carrier.active) || 'N/A'
									}}
								</span>
							</div>
						</div>
						<div
							*ngIf="
								productsService.ASSIGN_CARRIERS &&
								!utilService.isNullOrUndefined(usersList) &&
								usersList.length > 0 &&
								!utilService.isNullOrUndefined(userCarrierMapList)
							"
							fxFlex="25"
							fxLayoutAlign="end center"
						>
							<app-user-selector
								(userChanged)="setAssignee($event, carrier.id)"
								[selectedUsers]="
									utilService.isNullOrUndefined(userCarrierMap[carrier.id])
										? []
										: [getUserIdAssigned(carrier.id)]
								"
								[showAssignMe]="false"
								[singleselect]="true"
								[usersList]="usersList"
								[allUsersList]="allUsersList"
								customCssClass="form_field_width_auto"
								floatLabel="never"
								fxFlex
								placeholder="Assign Rep"
							></app-user-selector>
						</div>
					</div>
					<div class="mt-3 min-height-16" fxLayout="row">
						<div fxFlex="35" fxLayoutAlign="start center">
							<span *ngIf="!utilService.isNullOrUndefined(carrier.contactsTable.fullName)">
								{{ carrier.contactsTable.fullName }}
							</span>
						</div>
						<div fxFlex fxLayoutAlign="start center">
							<span *ngIf="!utilService.isNullOrUndefined(carrier.contactsTable.email)">
								{{ carrier.contactsTable.email }}
							</span>
						</div>
						<div fxFlex="25" fxLayoutAlign="end center">
							<span *ngIf="!utilService.isNullOrUndefined(carrier.contactsTable.phoneNumber)">
								{{ carrier.contactsTable.phoneNumber | mask: '(000) 000-0000' }}
							</span>
						</div>
					</div>
					<div class="mt-3" fxLayout="row">
						<div *ngIf="IS_PROJECTS_ENABLED" fxFlex>
							<div
								(click)="$event.stopPropagation()"
								class="carrier-search-dropdown-button"
								fxFlex="90"
								fxLayoutAlign="center center"
							>
								<app-projects-icon
									(carrierProjectToggled)="carrierProjectToggled($event, cIndex)"
									(loadMoreProjects)="getAllProjects()"
									(reloadList)="reloadProjectsList()"
									[carrierIDs]="[carrier.id]"
									[carrierToProjectsMap]="carrier.carrierToProjectsMap"
									[isCarrierSearch]="true"
									[isLoadingProjectsList]="isLoadingProjectsList"
									[nextPage]="projectsNextPage"
									[projects]="carrier.projects"
									[totalNumberOfProjects]="totalNumberOfProjects"
									projectSource="carrier_search_dropdown"
								>
								</app-projects-icon>
							</div>
						</div>

						<div fxFlex fxLayoutAlign="center center">
							<mat-spinner
								*ngIf="utilService.isNullOrUndefined(carrier.notesCount)"
								[diameter]="11"
								strokeWidth="1"
							></mat-spinner>
							<div
								(click)="$event.stopPropagation(); showNotes(carrier)"
								*ngIf="!utilService.isNullOrUndefined(carrier.notesCount)"
								fxFlex="100"
								fxLayoutAlign="center center"
							>
								<div
									*ngIf="carrier.notesCount > 0"
									class="carrier-search-dropdown-button"
									fxFlex="90"
									fxLayoutAlign="center center"
								>
									{{ carrier.notesCount + ' Note' + (carrier.notesCount > 1 ? 's' : '') }}
									<img class="ml-4 px-2" height="18px" src="./assets/icons/sticky-note.svg" />
								</div>
								<div
									*ngIf="carrier.notesCount == 0"
									class="carrier-search-dropdown-button"
									fxFlex="90"
									fxLayoutAlign="center center"
								>
									Add Notes
								</div>
							</div>
						</div>

						<div *ngIf="IS_TASKS_ENABLED" fxFlex fxLayoutAlign="end center">
							<div
								(click)="$event.stopPropagation()"
								class="carrier-search-dropdown-button"
								fxFlex="90"
								fxLayoutAlign="center center"
							>
								<app-tasks-icon
									(taskAddedEvent)="taskAdded($event)"
									(tasksUpdatedEvent)="tasksUpdated($event)"
									[carrier]="carrier"
									[isLoadingTasks]="isLoadingTasks"
									[taskList]="getTasksForCarrier(carrier.id)"
								>
								</app-tasks-icon>
							</div>
						</div>
					</div>
				</mat-card-content>
			</mat-card>
		</div>
	</mat-card-content>
</mat-card>
